// @ts-nocheck
import React from "react";
import styles from "./Editions.module.css";
import EditionsTimeline from "../../components/Editions/Editions";
import heroImg from "../../assets/img/heroes/arena_right.png";

const Editions = () => {
  return (
    <>
      <section className={styles.hero}>
        <img
          src={heroImg}
          alt="Arena Games - Edições anteriores"
          className={styles.heroImg}
        />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <span className={styles.kicker}>História do evento</span>
          <h1>Edições anteriores</h1>
          <p>
            Cada edição do Arena Games marca um passo na consolidação do maior
            evento de e-sports do IFSul. Conheça a trajetória de crescimento, os
            campeões e o impacto construído edição após edição.
          </p>
          <div className={styles.heroInfo}>
            <span>
              <i className="pi pi-flag" /> 5 edições realizadas
            </span>
            <span>
              <i className="pi pi-users" /> +350 participantes
            </span>
            <span>
              <i className="pi pi-chart-line" /> Crescimento contínuo
            </span>
          </div>
        </div>
      </section>

      <div className={styles.body}>
        <EditionsTimeline />
      </div>
    </>
  );
};

export default Editions;
